import MyMailbox from "./MyMailbox";

export default MyMailbox;
